module.exports = __webpack_public_path__ + "fd0904da45b9f40e9f41698cda9002b9.svg";